import { connect } from 'react-redux';
import { updateEventV2, getEventsV2 } from 'actions/website/entities/EventActions';
import { deleteEvent, fetchSuggestedAttireOptions } from 'actions/EventActions';
import { hideModal } from 'actions/ModalActions';

import EditVirtualEventModal from './EditVirtualEventModal';
import { formatVirtualEventStart } from '../../../../util/formDataUtil';

const mapDispatchToProps = dispatch => ({
  onDelete: id => {
    dispatch(deleteEvent(id, false)).then(() => {
      dispatch(getEventsV2());
      dispatch(hideModal());
    });
  },
  onSubmit: formValues => {
    const { date, start_at: startAt } = formValues;
    const request = {
      ...formValues,
      start_at: formatVirtualEventStart({ date, time: startAt }),
    };
    return dispatch(updateEventV2(request));
  },
  getAttireSuggestions: () => dispatch(fetchSuggestedAttireOptions()),
});

export default connect(null, mapDispatchToProps)(EditVirtualEventModal);



// WEBPACK FOOTER //
// ./src/components/manage/common/EditVirtualEventModal/index.js